import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { log as pilog } from "../Logging";
/**
 * Common code for logging API failures
 *
 * @param {object} error
 * @param {string} className
 */

export var handleAPIFailure = function handleAPIFailure(error, className) {
  var customerMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var supressLoggingCodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var loggerName = "handleSecureAjaxError";

  if (className) {
    loggerName = className;
  }

  var formattedMessage = customerMessage;
  var platformResponse = null;
  var log = pilog.getLogger(loggerName);

  try {
    if (error.response) {
      var _error$response = error.response,
          data = _error$response.data,
          status = _error$response.status,
          statusText = _error$response.statusText,
          config = _error$response.config; // The request was made and the server responded with a status code
      // that falls out of the range of 2xx

      if (data.code && !supressLoggingCodes[data.code]) {
        log.error("Platform request failed: ".concat(config.url));
        log.error("Platform response %o", data);
        log.error("Platform HTTP Status ".concat(status, " ").concat(statusText));
      }

      if (data) {
        platformResponse = data;
      }

      if (status) {
        platformResponse = _objectSpread({}, platformResponse, {
          "Status Code": status
        });
      }

      if (statusText) {
        platformResponse = _objectSpread({}, platformResponse, {
          Status: statusText
        });
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      log.error("Platform request error", error);
      formattedMessage = "".concat(formattedMessage, " - Unexpected error occurred");
    } else {
      // Something happened in setting up the request that triggered an Error
      log.error("%o", error);
    }
  } catch (error) {
    log.error("Failed to process Error! whoops", error);
  }

  log.debug("Formatted Message ".concat(formattedMessage));
  return {
    platformResponse: platformResponse,
    formattedMessage: formattedMessage
  };
};